var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75C58.2107 75 75 58.2107 75 37.5C75 16.7893 58.2107 0 37.5 0C16.7893 0 0 16.7893 0 37.5C0 58.2107 16.7893 75 37.5 75Z",
    fill: "#FFD9ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.643 40.9781C54.332 40.5601 46.91 30.7471 37.432 30.7471C27.954 30.7471 20.532 40.5591 20.221 40.9761C20.0775 41.1681 20 41.4014 20 41.6411C20 41.8808 20.0775 42.114 20.221 42.3061C20.533 42.7241 27.954 52.5371 37.432 52.5371C46.91 52.5371 54.332 42.7241 54.643 42.3081C54.7882 42.1168 54.8668 41.8832 54.8668 41.6431C54.8668 41.4029 54.7882 41.1694 54.643 40.9781ZM37.432 50.2841C30.451 50.2841 24.403 43.7721 22.614 41.6431C24.401 39.5131 30.435 33.0031 37.432 33.0031C44.429 33.0031 50.46 39.5151 52.251 41.6441C50.462 43.7741 44.429 50.2841 37.432 50.2841Z",
    fill: "#FF0185"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4337 35.9766C36.2224 35.9762 35.0486 36.3959 34.1121 37.1641C33.1757 37.9323 32.5346 39.0014 32.298 40.1893C32.0615 41.3772 32.2443 42.6104 32.8151 43.6787C33.3859 44.747 34.3095 45.5843 35.4285 46.0479C36.5475 46.5115 37.7926 46.5728 38.9517 46.2212C40.1108 45.8697 41.1121 45.1271 41.785 44.12C42.4579 43.1129 42.7608 41.9036 42.642 40.6983C42.5233 39.4929 41.9902 38.366 41.1337 37.5096C40.6479 37.0235 40.0711 36.6379 39.4362 36.3749C38.8014 36.1118 38.1209 35.9765 37.4337 35.9766ZM37.2337 40.9766C36.5437 40.9766 38.2887 42.6116 37.7157 42.2286C37.1427 41.8456 38.4607 43.0606 38.1977 42.4226C37.9347 41.7846 37.0977 42.9046 37.2337 42.2286C37.3697 41.5526 36.9507 42.4286 37.4337 41.9406C37.9167 41.4526 36.0697 42.0756 36.7467 41.9406C37.4237 41.8056 36.3407 41.6766 36.9777 41.9406C37.6147 42.2046 35.3987 42.3316 35.7777 42.9046C36.1567 43.4776 41.0777 42.6436 41.0777 42.9046C41.0777 42.9046 39.3217 38.5526 38.6677 39.2046C38.0137 39.8566 38.1527 40.9736 37.2287 40.9746L37.2337 40.9766Z",
    fill: "#FF0185"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38C37.9704 38.0249 38.9015 38.3884 39.632 39.0277C40.3626 39.6669 40.8465 40.5415 41 41.5",
    stroke: "#FAC7E2",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9355 24.2998L29.8666 28.2068L27.9355 24.2998Z",
    fill: "#FF0185"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9355 24.2998L29.8666 28.2068",
    stroke: "#FF0185",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3008 22L37.6678 27.069L37.3008 22Z",
    fill: "#FF0185"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3008 22L37.6678 27.069",
    stroke: "#FF0185",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0363 23.9922L45.0703 27.8812L47.0363 23.9922Z",
    fill: "#FF0185"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0363 23.9922L45.0703 27.8812",
    stroke: "#FF0185",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfViews);
export default __webpack_public_path__ + "static/media/PfViews.e071b7a76baa770d2b4e01ba77699303.svg";
export { ForwardRef as ReactComponent };